import {
  mapGetters,
} from 'vuex';

export const authComputed = {
  ...mapGetters(['auth/loggedIn']),
};

export const set = (state, [key, payload]) => {
  state[key] = payload;
};

export const add = (state, [key, payload]) => {
  state[key].push(payload);
};

export const append = (state, [key, payload]) => {
  state[key] = [...state[key], ...payload];
};

export const prepend = (state, [key, payload]) => {
  state[key].push(...payload);
};

export const update = (state, [key, { id, payload }]) => {
  state[key] = state[key].map((item) => {
    if (item.id === id) {
      item = {
        ...item,
        ...payload,
      };
    }

    return item;
  });
};

export const remove = (state, [key, id]) => {
  const index = state[key].findIndex((item) => item.id === id);
  state[key].splice(index, 1);
};
